export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_ERROR = "API_ERROR";
export const VTR_LIST_REQUEST = "VTR_LIST_REQUEST";
export const VTR_LIST_SUCCESS = "VTR_LIST_SUCCESS";
export const VTR_LIST_ERROR = "VTR_LIST_ERROR";
export const LOAD_IVRS_REQUEST = "LOAD_IVRS_REQUEST";
export const LOAD_IVRS_SUCCESS = "LOAD_IVRS_SUCCESS";
export const LOAD_IVRS_ERROR = "LOAD_IVRS_ERROR";
export const SAVE_TRIP_SUCCESS = "SAVE_TRIP_SUCCESS";
export const SAVE_EFFORT_SUCCESS = "SAVE_EFFORT_SUCCESS";
export const SET_TRIP_SUCCESS = "SET_TRIP_SUCCESS";
export const DELETE_TRIP = "DELETE_TRIP";
export const DELETE_EFFORT = "DELETE_EFFORT";
export const DELETE_CATCH = "DELETE_CATCH";
export const DELETE_SALES = "DELETE_SALES";
export const SUBMIT_TRIP = "SUBMIT_TRIP";
export const SUBMIT_TRIP_SUCCESS = "SUBMIT_TRIP_SUCCESS";
export const SUBMIT_TRIP_ERROR = "SUBMIT_TRIP_ERROR";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const VTR_TRIP_REQUEST = "VTR_TRIP_REQUEST";
export const VTR_TRIP_DATA_REQUEST = "VTR_TRIP_DATA_REQUEST";
export const SAVE_OPEN_TRIP_SUCCESS = "SAVE_OPEN_TRIP_SUCCESS";
export const SAVE_NEW_TRIP_SUCCESS = "SAVE_NEW_TRIP_SUCCESS";
export const SET_IDXDB_VALIDATIONS = "SET_IDXDB_VALIDATIONS";
export const UPDATE_SUCCESS_VALIDATIONS = "UPDATE_SUCCESS_VALIDATIONS";
export const UPDATE_ERROR_VALIDATIONS = "UPDATE_ERROR_VALIDATIONS";
export const UPDATE_EFFORT_SUCCESS = "UPDATE_EFFORT_SUCCESS";
export const UPDATE_TRIP_SUCCESS = "UPDATE_TRIP_SUCCESS";
export const SAVE_EFFORT_REDIRECT_RESET = "SAVE_EFFORT_REDIRECT_RESET";
export const SAVE_TRIP_REDIRECT_RESET = "SAVE_TRIP_REDIRECT_RESET";
export const UPDATE_CATCH_SUCCESS = "UPDATE_CATCH_SUCCESS";
export const NO_EFFORT_REASON_TRIP = "NO_EFFORT_REASON_TRIP";
export const NEW_SALES_SUCCESS = "NEW_SALES_SUCCESS";
export const UPDATE_SALES_SUCCESS = "UPDATE_SALES_SUCCESS";
export const SET_ERROR = "SET_ERROR";
export const SET_TRIP_REDIRECT = "SET_TRIP_REDIRECT";
export const RESET_CACHE = "RESET_CACHE";
export const USER_OFFLINE_SUCCESS = "USER_OFFLINE_SUCCESS";
export const USER_OFFLINE_ERROR = "USER_OFFLINE_ERROR";
export const SET_IDXDB_LOADING = "SET_IDXDB_LOADING";
export const SET_IDXDB_ERROR = "SET_IDXDB_ERROR";
export const LOAD_VALIDATIONS_SUCCESS = "LOAD_VALIDATIONS_SUCCESS";
export const LOAD_VALIDATIONS_ERROR = "LOAD_VALIDATIONS_ERROR";
